/**
 * @generated SignedSource<<8bbd5eb7b0ae4b63a1b0ee853e66c03d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type McpServersOnboardingContentTestConnectionMutation$variables = {
  id: any;
};
export type McpServersOnboardingContentTestConnectionMutation$data = {
  readonly testCustomMcpServerConnection: {
    readonly error: string | null | undefined;
    readonly oauthUrl: string | null | undefined;
    readonly success: boolean;
    readonly tools: ReadonlyArray<string>;
  };
};
export type McpServersOnboardingContentTestConnectionMutation = {
  response: McpServersOnboardingContentTestConnectionMutation$data;
  variables: McpServersOnboardingContentTestConnectionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "TestConnectionPayload",
    "kind": "LinkedField",
    "name": "testCustomMcpServerConnection",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tools",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "oauthUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "McpServersOnboardingContentTestConnectionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "McpServersOnboardingContentTestConnectionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cbb96add93b9243a8bad13fd8982ccef",
    "id": null,
    "metadata": {},
    "name": "McpServersOnboardingContentTestConnectionMutation",
    "operationKind": "mutation",
    "text": "mutation McpServersOnboardingContentTestConnectionMutation(\n  $id: GlobalID!\n) {\n  testCustomMcpServerConnection(id: $id) {\n    success\n    tools\n    error\n    oauthUrl\n  }\n}\n"
  }
};
})();

(node as any).hash = "3ae6656e7bf4706b02987837f5163a65";

export default node;
